import React, { memo, useCallback, useMemo } from "react";
import { SortControlProps } from "../../types";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { useTranslate } from "helpers";

const SortControl: React.FC<SortControlProps> = (props) => {
  const { rowsSizeOptions, onChangeRowsSize, width } = props;

  const { t } = useTranslate();

  const transformRowsSizeOptions = (value: number): DropdownOption => {
    return {
      text: value.toString(),
      value: value.toString(),
    };
  };

  const rowsSizeOptionsDropdownItems = useMemo(() => {
    return rowsSizeOptions.map((item) => {
      return transformRowsSizeOptions(item);
    });
  }, [rowsSizeOptions]);

  const handleRowSizeOptionChange = useCallback(
    (e: any, name: string, item: DropdownOption) => {
      if (item.value) onChangeRowsSize(item.value);
    },
    [onChangeRowsSize]
  );

  return (
    <>
      <div className="flex flex-1 mr-3 items-center">
        <div className="text-sm">{t("admin.table.pagination.sort.show")}</div>
        <div className="ml-2 mr-2 flex-grow">
          <Dropdown
            name="rowSize"
            options={rowsSizeOptionsDropdownItems}
            onChange={handleRowSizeOptionChange}
            direction="up"
            width={width}
            cssClassName="bg-white"
          />
        </div>
        <div className="text-sm"> {t("admin.table.pagination.sort.results")}</div>
      </div>
    </>
  );
};

export default memo(SortControl);
